module.exports = __webpack_public_path__ + "static/media/group2-mobile.adf0311a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group2-mobile.svg
// module id = 1359
// module chunks = 0